import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Button from '../elements-buttons/Button';
import NumberField from '../app-main/components/reduxForms/fields/NumberField/NumberField';
import Dash from '../elements-shapes/Dash';
import Plus from '../elements-shapes/Plus';

const QuantityStepper = ({
  name = '',
  placeholder = '',
  parse,
  onChange = null,
  validate = null,
  onDecrementClick = null,
  onIncrementClick = null,
  disableDecrementBtn = false,
  disableIncrementBtn = false,
  showErrorOnChange = false,
  index = null
}) => {
  const decrementBtn = (
    <Button
      onClick={onDecrementClick}
      className="flex-grow btn btn-no-focus margin-md-right text-gray-600"
      childrenWrapperClassName="flex center"
      disabled={disableDecrementBtn}
      type="button"
      attributes={{ 'data-testing-id': `decrement-button-${index}` }}
    >
      <Dash />
    </Button>
  );

  const incrementBtn = (
    <Button
      onClick={onIncrementClick}
      className="flex-grow btn btn-no-focus text-gray-600"
      childrenWrapperClassName="flex center"
      disabled={disableIncrementBtn}
      type="button"
      attributes={{ 'data-testing-id': `increment-button-${index}` }}
    >
      <Plus />
    </Button>
  );

  return (
    <div className="QuantityStepper">
      <Field
        className="flex-grow"
        inputClassName="quantity-input margin-md-right"
        name={name}
        component={NumberField}
        preInputElements={decrementBtn}
        postInputElements={incrementBtn}
        placeholder={placeholder}
        parse={parse}
        onChange={onChange}
        validate={validate}
        showErrorOnChange={showErrorOnChange}
        returnErrorMessage
        attributes={{ 'data-testing-id': `quantity-input-${index}` }}
      />
    </div>
  )
}

QuantityStepper.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  parse: PropTypes.func,
  onBlur: PropTypes.func,
  validate: PropTypes.func,
  showErrorOnChange: PropTypes.bool,
  disableDecrementBtn: PropTypes.bool,
  disableIncrementBtn: PropTypes.bool,
  onDecrementClick: PropTypes.func,
  onIncrementClick: PropTypes.func,
  onChange: PropTypes.func
}

export default QuantityStepper;
